import tidalIcon from './components/tidal-icon.vue';

export default tidalIcon;

export * from './icons/index.ejs.js';
